import type { Drone, PartType } from '../../../types';

// The canonical list of parts tracked as discrete per-unit counters — the edit
// panel's serial-visibility rule (getIsSerialShown) shares it. Props are virtual
// units — one per motor position (SR-24).
export const PER_UNIT_PART_TYPES: readonly PartType[] = ['motor', 'propSet', 'pumpSealKit'];

// Per-unit count readers for exactly the parts in PER_UNIT_PART_TYPES; the
// membership gate in getUnitCount keeps the two from drifting.
const unitCountReaders: Partial<Record<PartType, (drone: Drone) => number>> = {
    motor: drone => drone.motors.length,
    propSet: drone => drone.motors.length,
    pumpSealKit: drone => drone.pumps.length
};

// How many discrete units of a part this drone carries. Parts tracked as a single
// aggregate counter report 0 so the unit selector stays hidden.
export const getUnitCount = ({ drone, partType }: { drone: Drone; partType: PartType }): number => {
    if (!PER_UNIT_PART_TYPES.includes(partType)) {
        return 0;
    }

    return unitCountReaders[partType]?.(drone) ?? 0;
};
